document.addEventListener("DOMContentLoaded", function () {
    jQuery(function ($) {
        $('.open-modal').on('click', function (e) {
            e.preventDefault();
            $.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                dataType: "html",
                data: {
                    action: "open_product_info_modal",
                    product_id: $(this).data("product-id"),
                    main: $(this).data("main"),
                },
                success: function (response) {
                    let tempDiv = document.createElement('div');
                    tempDiv.innerHTML = response;

                    let modal = tempDiv.querySelector('.modal-product-info');

                    if (modal) {
                        document.body.appendChild(modal);

                        $(modal).modal('show');
                        modal.addEventListener('hidden.bs.modal', function () {
                            modal.remove();
                        });
                    }

                },
            });
        });

        $('.btn-zip-check').on('click', function (e) {
            e.preventDefault();

            $.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                dataType: "html",
                data: {
                    action: "open_zip_check_modal",
                },
                success: function (response) {
                    let tempDiv = document.createElement('div');
                    tempDiv.innerHTML = response;

                    let modal = tempDiv.querySelector('.modal-zip');

                    if (modal) {
                        document.body.appendChild(modal);

                        $(modal).modal('show');
                        modal.addEventListener('hidden.bs.modal', function () {
                            modal.remove();
                        });
                    }

                },
            });
        });
        $('body').on('click', '.check-zip', function (e) {
            e.preventDefault();
            $input = $('body .zip-input').val();
            $.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                dataType: "html",
                data: {
                    action: "check_zip",
                    zip: $input,
                },
                beforeSend: function () {
                    $('.zip-result-success').removeClass('is-active');
                    $('.zip-result-fail').removeClass('is-active');
                },
                success: function (response) {
                    response = JSON.parse(response);
                    if (response.success) {
                        $('.zip-result-success').addClass('is-active');
                        $('.zip-result-fail').removeClass('is-active');
                    } else {
                        $('.zip-result-fail').addClass('is-active');
                        $('.zip-result-success').removeClass('is-active');
                    }
                },
            });
        });
    });
});